module.exports = __webpack_public_path__ + "img/camera-upload.37805a3a.svg";